<template>
  <div id="app" :class="{'en': isEn}">
    <router-view :key="activeDate"/>
  </div>
</template>

<script>
import "@/assets/ele-wistbox-ui/msgbox/_msgbox.scss";
import "@/assets/ele-wistbox-ui/breadcrumb/_breadcrumb.scss";
import "@/assets/ele-wistbox-ui/sidebar/_sidebar.scss";
import "@/assets/ele-wistbox-ui/dropdown/_dropdown.scss";
import "@/assets/ele-wistbox-ui/input/_input.scss";
import "@/assets/ele-wistbox-ui/button/_button.scss";
import '@/assets/ele-wistbox-ui/icon/_icon.scss'
import "@/assets/ele-wistbox-ui/table/_table.scss";
import "@/assets/ele-wistbox-ui/pagination/_pagination.scss";
import "@/assets/ele-wistbox-ui/radio&checkBox/_radio&checkBox.scss";
import "@/assets/ele-wistbox-ui/dialog/_dialog.scss";
import "@/assets/ele-wistbox-ui/other/_other.scss";
import "@/assets/ele-wistbox-ui/tab/_tab.scss";
import "@/assets/ele-wistbox-ui/toast/toast.scss";
import "@/assets/ele-wistbox-ui/ueditor/_ueditor.scss";
import "./assets/css/common.scss";
import "./assets/css/zhWeb.scss";
import { mapMutations } from "vuex";

export default {
  name: "App",
  data: function() {
    return {
      activeDate: (new Date()).toString()
    };
  },
  mounted() {
		document.oncontextmenu = function (e) {
		  return false
		}
    $(document).on("click", ".confirm", function() {
      $(this).attr("disabled", true);
      setTimeout(() => {
        $(this).attr("disabled", false);
      }, 3000);
    });
		$(document).on('click', '.tobuybtnPlan', function () {
		  $(this).attr('disabled', true)
		  $(this).addClass('wis-disabled')
		  setTimeout(() => {
		    $(this).attr('disabled', false)
		    $(this).removeClass('wis-disabled')
		  }, 2000)
		})
		$(document).on('click', '.confirm', function () {
		  $(this).attr('disabled', true)
		  if (
		    ($(this).attr('class') && $(this).attr('class').indexOf('nodiscss')) < 0
		  ) {
		    $(this).addClass('wis-disabled')
		  }
		  setTimeout(() => {
		    $(this).attr('disabled', false)
		    $(this).removeClass('wis-disabled')
		  }, 100)
		})
		
		
    //  设置初始语言
    let langMode = localStorage && localStorage.getItem("lang");
    if (!!langMode && (langMode=='zh' || langMode=='en' || langMode=='tw')) {
      this.$i18n.locale = langMode;
      this.CHANGELANG(langMode);
    } else {
      let browerLang = (navigator.language || navigator.browserLanguage).toLowerCase(),
        tarLang = browerLang.indexOf("zh") > -1 ? "zh" : (browerLang.indexOf("en") > -1 ? "en" : "tw");
      localStorage.setItem("lang", tarLang);
      this.CHANGELANG(tarLang);
    }
    document.title = this.$t("common.documentTitle");
    // 获取配置的一些东西
    this.request.get(`${this.WITSBOX_ENV_PARAM.baseUrl}/common/systemParameter/aliyun`).then(res=>{
            if(res.dataModel) {
              this.WITSBOX_ENV_PARAM.ossObject = {
                accessKeyId: res.dataModel.accessKey,
                accessKeySecret: res.dataModel.accessSecret,
                bucket: res.dataModel.bucket,
                region: res.dataModel.region
              }
            }
          })
  //  document.addEventListener('click', this.globalClick);
  },
  beforeDestroy(){
    // document.removeEventListener('click', this.globalClick);
  },
  computed: {
    isEn: function() {
      return this.$store.state.common.lang == "en";
    },
    language() {
      return this.$store.state.common.lang
    }
  },
  watch: {
    language(val) {
      this.activeDate = (new Date()).toString()
    },
		$route: {
		  handler(val, oldval) {
	
			
		  },
		  // 深度观察监听
		  deep: true
		}
  },

  methods: {
    // globalClick (){
    //     if(this.$route.path == '/study/center') {
    //       console.log('globalClick=======')
    //       this.$root.Bus.$emit('globalClick')
    //     }
        
    //   },
    ...mapMutations("common", ["CHANGELANG"])
  }
};
</script>

<style>
#app {
  font-family: "Microsoft YaHei", "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #333;
  height: 100%;
}

@font-face {
  font-family: "font-words";
  src: url("./assets/font/font.ttf") format("truetype");
}
@font-face {
  font-family: "font-time";
  src: url("./assets/font/font-time.ttf") format("truetype");
}
@font-face {
  font-family: "font-certificate";
  src: url("./assets/font/certificate-level.ttf") format("truetype");
}

@font-face {
  font-family: 'font-sourceHanSerifSC';
  src: url('./assets/font/NotoSerif-Regular.ttf')format('truetype');
}

</style>



// WEBPACK FOOTER //
// src/App.vue